module.exports = __webpack_public_path__ + "static/img/h5.b8fc81d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/h5.png
// module id = TD9p
// module chunks = 34